export enum LocalStorageKeys {
  moovToken = 'moov_token',
  returnUrl = 'moov_return_url',
  userPersonalInfo = 'user_personal_info',
  partialMotivationsData = 'partial_motivations_data',
  skipRelationshipQuestionData = 'skip_relationship_question_data',
  userSelectedLocale='user_selected_locale',
  resellerSelectedOrg='reseller_selected_org',
  teamViewFilterBYManager='tv_filter_by_manager',
  stateViewFilterBYManager='sv_filter_by_manager',
  teamViewScope = 'tv_view_scope',
  lastActiveChatId ='last_active_chat_id',
  teamViewDriversOnly ='tv_drivers_only',
  presentTeamPeers = 'tv_present_team_peers',
  chatAudioTTSUserEnabledKey = 'cv_audio_tts_user_enabled'
}
